/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Legal_Placeholder_NameInputs */

const da_legal_placeholder_name = /** @type {(inputs: Legal_Placeholder_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[virksomhedens navn]`)
};

/** @type {(inputs: Legal_Placeholder_NameInputs) => LocalizedString} */
const en_legal_placeholder_name = da_legal_placeholder_name;

/**

* @param {Legal_Placeholder_NameInputs} inputs
* @param {{ locale?: "da" | "en" }} options
* @returns {LocalizedString}
*/
export const legal_placeholder_name = /** @type {((inputs?: Legal_Placeholder_NameInputs, options?: { locale?: "da" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Legal_Placeholder_NameInputs, { locale?: "da" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_legal_placeholder_name(inputs)
	return /** @type {LocalizedString} */ ("[virksomhedens navn]")
});